import React, { useEffect } from 'react'
import { alertRef } from '../../../../App';
import Dropdown from '../../../../Components/Dropdown/Dropdown';
import Stepper from '../../../../Components/Stepper/Stepper';
import { Button, Input, Textarea } from '../../../../Components/StyledComponents';
import { convertCost, languageInit, onTranslation, onlyNum } from '../../../../Utils/functions';
import './CreateOptionGroup.scss';
import Select from 'react-select';
import axios from 'axios';
import { support_language } from '../../../../Utils/services';
import { useSelector } from 'react-redux';
import CheckLanguage from '../../../../Components/TableOrder/CheckLanguage';

const CreateOptionGroup = ({createOptionGroup}) => {
    const [ step, setStep ] = React.useState(1)
    const [ name, setName ] = React.useState({})
    const [ desc, setDesc ] = React.useState({})
    const [ options, setOptions ] = React.useState([{ PosItem:'', Name : languageInit(), Price : 0 , Description : languageInit() }])
    const [ isRequire, setIsRequire ] = React.useState(true)
    const [ selectableCount, setSelectableCount ] = React.useState({ Min : 1, Max : 1 })
    const [ posMenuList, setPosMenuList ] = React.useState([]);

    const [ force_update, setForceUpdate ] = React.useState(false);

    const language = useSelector(state => state.tableorder.language);

    useEffect(()=>{
        getPosMenuList();
        setName({...languageInit()});
        setDesc({...languageInit()});
    },[]);

    useEffect(() => {
        let arr = selectableCount;
        if( isRequire ) arr.Min = 1;
        else arr.Min = 0
        setSelectableCount(arr);
        setForceUpdate(!force_update);
    },[isRequire])

    const getPosMenuList = () => {
        axios.get('/api/table/order/pos/info/Menu')
        .then((data)=>{
            setPosMenuList(data.data.Menu.map(item => ({
                value: item.Code, 
                label:`${item.Code} | ${item.Name} | ${convertCost(item.Price)}원`, 
                item:{PosItem: item.Code, Name:item.Name, Price:item.Price}
            })))
        })
    }

    const selectMenu = (event, index) => {
        let tmpMenuSelectList = options;
        tmpMenuSelectList[index] = {...tmpMenuSelectList[index], ...event.item, Name: {...tmpMenuSelectList[index].Name, ko: event.item.Name}};
        setOptions([...tmpMenuSelectList]);
    }

    const handleOptionName = (val,i) => {
        let arr = options;

        arr[i].Name = val;

        setOptions([...arr])
    }

    const handleOptionDescription = (val,i) => {
        let arr = options;

        arr[i].Description = val;

        setOptions([...arr])
    }

    const removeOption = (i) => {
        let arr = options;

        arr.splice(i,1);

        setOptions([...arr])
    }

    const addOption = () => {
        if( options.length > 0 && (options[options.length - 1].Name.ko === '' || typeof options[options.length - 1].Name.ko === 'undefined') ){
            alertRef.current.showAlert({ title : '이전 항목을 입력해주세요.', subTitle : '', isCancel : true, cancelText : '닫기', isConfirm : false})
            return
        }
        setOptions(old => [...old,{ PosItem:'', Name : languageInit(), Price : 0, Description : languageInit()}])
    }

    const nextStep = () => {
        if(step !== 5) setStep(old => old+1)
        else post()
    }

    const getOptions = () => {
        let arr = []

        for(let i=0; i<options.length; i++){
            arr.push({ key : i+1 + '개', value : i+1 })
        }

        return arr;
    }

    const post = () => {
        let arr = [];
        for(let i=0; i<options.length;i++){
            arr.push({ PosItem : options[i].PosItem, Name : options[i].Name, Description : options[i].Description })
        }
        createOptionGroup({
            Name : name,
            Description : desc,
            Options : arr,
            isRequire : isRequire,
            SelectableCount : {
                Min : parseInt(selectableCount.Min),
                Max : parseInt(selectableCount.Max)
            }
        })
    }

    const isDisabled = () => {
        if(step === 1 && name.ko?.trim() === '' ) return true
        else if( step === 2 && ( options.length === 0 || !options.every(item => (item.PosItem !== '' && item.Name !== '')) )) return true
        else return false
    }

    const translationBtn = async () => {
        const trans_language = Object.entries(language).map(([key, value]) => value === true && key).filter(item => item !== false);
        const trans_data = [name.ko, desc.ko, ...options.map(item => item.Name.ko)];
        const trans_value = ['name', 'desc', ...options.map((item, index) => ({value: 'options', index: index, key: 'Name', data: item}))];
        const data = await onTranslation(trans_language, trans_data, trans_value);
        setName({...data.name});
        setDesc({...data.desc});
        setOptions([...data.options]);
    };
    return (
        <div className='create-option-group'>
            <Stepper maxStep={5} step={step} containerStyle={{ marginBottom : step === 4 ? 0 : 40 }}/>
            {
                step === 5 && <p className="warn-text">모두 입력되었어요. 마지막으로 확인해주세요.</p>
            }
            {
                step === 1 &&
                <>
                    <div className='row'>
                        <p className='label'>옵션그룹명</p>
                        <Input
                            value={name.ko}
                            onChange={(e) => setName({...name, ko: e.target.value})}
                            style={{ width : 347 }}
                            placeholder="예) 맛선택, 사이드메뉴 추가 등"
                        />
                    </div>

                    <div className='row' style={{ alignItems : 'flex-start', marginTop : 16 }}>
                        <p className='label'>설명(선택)</p>
                        <Textarea
                            value={desc.ko}
                            onChange={(e) => setDesc({...desc, ko: e.target.value})}
                            style={{ width : 347, height : 173 }}
                            placeholder="예) 추가 옵션입니다 (1개 이상 필수)"
                        />
                    </div>
                </>
            }

            {
                step === 2 &&
                <>
                    <p className='label'>옵션정보</p>
                    <p className="label" style={{width:'100%', color:'#f95f53'}}>※ 테이블 오더에 보여지는 옵션 이름만 설정할 수 있습니다.</p>
                    <p className="label" style={{width:'100%', color:'#f95f53'}}>※ 금액 변경을 원하실 경우 포스에서 옵션 정보를 변경해주세요.</p>
                    {
                        options.map((data,i) => {
                            return (
                                <div key={i}>
                                    <div className="row" style={{ marginTop : 16, marginBottom: 8 }}>
                                        <Input value={data.PosItem} disabled={true} placeholder="옵션코드" style={{ color:'#0F0F0F', width : 80, paddingLeft: 8, paddingRight: 8 }}/>
                                        <Input value={data.Name.ko} onChange={(e) => handleOptionName({...data.Name, ko: e.target.value},i)} placeholder="예) 1인분, 300g 등" style={{ width : 150, marginLeft: 16, marginRight: 16, paddingLeft:16, paddingRight:16 }}/>
                                        <label htmlFor={`price${i}`} data-domain="원">
                                            <Input htmlFor={`price${i}`} value={convertCost(data.Price)} disabled={true} placeholder="0" style={{ color:'#0F0F0F', width : 100, paddingLeft:16, paddingRight:16 }}/>
                                        </label>
                                        <Button variant="sub" onClick={()=> removeOption(i)} style={{ color:'0F0F0F', width : 28, height : 28, borderRadius : 100, boxSizing : 'border-box', padding : 0, marginLeft : 16 }}>
                                            <img src={require('../../../../aseets/icons/minus_pink.svg').default} style={{ width : 16, height : 16, marginTop : 6 }} />
                                        </Button>
                                    </div>
                                    <Select options={posMenuList} placeholder={'연동할 포스 메뉴를 선택해주세요'} onChange={event => selectMenu(event, i)} />
                                    {/* <Input htmlFor={`price${i}`} value={data.Description} onChange={(e) => handleOptionDescription(e.target.value,i)} placeholder="옵션에 대한 설명을 입력해주세요." style={{ width : '100%', marginTop : 8 }}/> */}
                                    {
                                        i < (options.length - 1) && <div className='divider' style={{ marginTop : 24, marginBottom : 24 }}></div>
                                    }
                                </div>           
                            )
                        })
                    }
                    <Button variant="sub" small onClick={() => addOption()} style={{ width : 113, marginTop : 16 }}>
                        <div className='row'>
                            <img src={require('../../../../aseets/icons/plus_pink.svg').default} style={{ width : 24, height : 24, marginRight : 8 }} />
                            추가하기
                        </div>
                    </Button>
                </>
            }

            {
                step === 3 &&
                <div style={{ alignItems : 'flex-start' }}>
                    <CheckLanguage>
                        <div style={{display:'flex', flexDirection:'column'}}>
                        <div className='btn-row' style={{margin:0, alignItems:'center'}}>
                            <p className='label' style={{flex:1, textAlign:'right', margin: 0, marginRight: 8, color:'#f95f53'}} >서비스 준비 중입니다.</p>
                            <Button variant="sub" small className='save-btn' fontSize={16} onClick={translationBtn} disabled={true || name.ko === '' || typeof name.ko === 'undefined'}>
                                자동번역
                            </Button>
                        </div>
                        {support_language.map((item, index) => {
                            if(language[item.value])
                                return (
                                    <div style={{display:'flex', flexDirection:'column', marginBottom: 24, rowGap: 8}} key={index}>
                                        {index !== 0 && <div className='divider' style={{margin: '16px 0'}} />}
                                        <p className='title' style={{margin: 0}}>{item.text}</p>
                                        <div className="row">
                                            <p className='label'>메뉴명</p>
                                            <Input value={name[item.value]} placeholder={"예) 매운떡볶이"} onChange={(e) => setName({...name, [item.value]: e.target.value})} style={{ width : '100%' }} />
                                        </div>
                                        <div className="row">
                                            <p className='label'>설명</p>
                                            <Textarea
                                                value={desc[item.value]}
                                                onChange={(e) => setDesc({...desc, [item.value]: e.target.value})}
                                                style={{ width : '100%', height : 173 }}
                                                placeholder="예) 세트 구성 메뉴입니다."
                                            />
                                        </div>
                                        
                                        <div className="row">
                                            <p className='label'>가격구성</p>
                                            <div style={{ display:'flex', flexDirection:'column', width:'100%', gap: 8 }}>
                                                {options.map((data,i) => (
                                                    <Input key={i} value={options[i].Name[item.value]} onChange={(e) => handleOptionName({...options[i].Name, [item.value]: e.target.value}, i)} placeholder="예) 1인분, 300g 등" style={{ width : '100%' }}/>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )
                        })}
                        </div>
                    </CheckLanguage>
                </div>
            }

            {
                step === 4 &&
                <>
                    <p className='label'>옵션정보</p>
                    <div className='row' style={{ marginTop : 16 }}>
                        <button className={`${ isRequire ? 'selected-btn' : 'unselected-btn'}`} style={{ marginRight : 32, width : 180 }} onClick={() => setIsRequire(true)}>
                            <div className='row' style={{ justifyContent : 'center' }}>
                                {
                                    isRequire ?
                                    <img src={require('../../../../aseets/icons/check.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                                    :
                                    <img src={require('../../../../aseets/icons/check_white.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                                }
                                옵션 선택시 주문가능
                            </div>
                        </button>

                        <button className={`${ !isRequire ? 'selected-btn' : 'unselected-btn'}`} style={{ width : 232 }} onClick={() => setIsRequire(false)}>
                            <div className='row' style={{ justifyContent : 'center' }}>
                                {
                                    isRequire ?
                                    <img src={require('../../../../aseets/icons/close.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                                    :
                                    <img src={require('../../../../aseets/icons/close_white.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                                }
                                옵션 선택하지 않아도 주문가능
                            </div>
                        </button>
                    </div>

                    <p className='label' style={{ marginTop : 40 }}>옵션 개수</p>
                    <p className='label' style={{ marginTop : 8, marginBottom : 16, opacity : 0.5, width : 'fit-content' }}>현재 옵션 그룹에는 {options.length}개의 옵션이 있어요.</p>
                    <div className='row'>
                        {
                            isRequire &&
                            <>
                                <p className='drop-text'>최소</p>
                                <Dropdown
                                    width={161}
                                    options={getOptions()}
                                    onItemClick={(val) => setSelectableCount({...selectableCount, Min : val})}
                                    selected={true}
                                    value={selectableCount.Min}
                                    btnStyle={{ marginRight : 16 }}
                                    prefix={'개'}
                                />
                            </>
                        }
                        <p className='drop-text'>최대</p>
                        <Dropdown
                            width={isRequire ? 161:379}
                            options={getOptions()}
                            onItemClick={(val) => setSelectableCount({...selectableCount, Max : val})}
                            selected={true}
                            value={selectableCount.Max}
                            prefix={'개'}
                        />
                    </div>
                </>
            }
            {
                step === 5 &&
                <div>
                    <p className="label" style={{ marginTop : 16 }}>메뉴명</p>
                    <p className="text">{name.ko}</p>
                    <div className="divider" style={{ margin : 0 }} /> 

                    <p className="label" style={{ marginTop : 16 }}>가격 구성</p>
                    <div style={{ marginTop : 8, marginBottom : 16 }}>
                    {
                        options.map((data,i) => {
                            return (
                                <React.Fragment key={i}>
                                    {i !== 0 && <div className="divider" style={{ margin : '8px 0' }} />}
                                    <p key={i} className="text" style={{ margin : 0}}>{data.Name.ko} : {convertCost(data.Price)}원</p>
                                </React.Fragment>
                            )
                        })
                    }
                    </div>
                    <div className="divider" style={{ margin : 0 }} />

                    <p className="label" style={{ marginTop : 16 }}>메뉴설명</p>
                        <p className="text">{desc.ko}</p>
                    <div className="divider" style={{ margin : 0 }} />
                    {support_language.map(item => language[item.value] && 
                        <>
                            <p className="title" style={{marginTop : 16}}>{item.text}</p>
                            <p className="label" style={{margin: 0}}>메뉴명</p>
                            <p className="text">{name[item.value]}</p>

                            <p className="label" style={{ marginTop : 16 }}>가격 구성</p>
                            <div style={{ marginTop : 8, marginBottom : 16 }}>
                            {
                                options.map((data,i) => {
                                    return (
                                        <p key={i} className="text" style={{ margin : 0}}>{data.Name[item.value]}</p>
                                    )
                                })
                            }
                            </div>

                            <p className="label" style={{ marginTop : 16 }}>설명</p>
                                <p className="text">{desc[item.value]}</p>
                            <div className="divider" style={{ margin : 0 }} />
                        </>
                    )}

                    <p className="label" style={{ marginTop : 16 }}>옵션 개수</p>
                    <p className="text">{isRequire ? `최소 ${selectableCount.Min}개 ` : ''} 최대 {selectableCount.Max}개</p>
                </div>
            }

            <div className='btn-row'>
                {
                    step !== 1 &&
                    <Button variant="outline" className='save-btn' fontSize={16} onClick={() => setStep(old => old -1)} style={{ marginRight : 24 }}>
                        이전
                    </Button>
                }
                <Button variant="main" className='save-btn' fontSize={16} onClick={() => nextStep()} disabled={isDisabled()}>
                    {step === 5 ? '추가하기' : '다음'}
                </Button>
            </div>
        </div>
    )
}

export default CreateOptionGroup;